/**
 * 分分彩抽奖结果
 */
import normalMode from "../../normalMode";
import gameConfig from "../../../../engines/configs/gameConfig";
import {EventParamsTypeConstant} from "../const/EventParamsTypeConstant";

export interface LotteryFFCResult {
    minuteDefine : string;//分钟期数
    lotteryNum : number ;//开奖结果
}

/**
 * 分分彩Manager
 */
export default class LotteryFFCManager{

    constructor( gameLayer : normalMode ) {
        this.mGameLayer = gameLayer;
    }

    mGameLayer : normalMode;
    //历史抽奖结果
    historyResultArray : LotteryFFCResult[] = [];
    //本期购买号码
    currBetLotteryNumber : number[] = [];

    private lotterySeconds : number = gameConfig.LOTTERY_SECONDS;
    static readonly MAX_LOTTERY_VALUE = 33;//最大开奖号码

    // readonly ChineseZodiacArray : string[] = ['鼠','牛','虎','兔','龙','蛇','马','羊','猴','鸡','狗','猪'];
    // /**
    //  * 开始
    //  */
    // start(){
    //     let currSeconds = new Date().getSeconds();
    //     this.mGameLayer.scheduleOnce(()=>{
    //         this.openPrize();
    //     },60 - currSeconds );
    // }
    //
    // /**
    //  * 开奖
    //  */
    // openPrize(){
    //     if  ( this.historyResultArray.length == 20 ) {
    //         this.historyResultArray.pop();
    //     }
    //     let resultIndex = Math.floor( Math.random() * this.ChineseZodiacArray.length ) ;
    //     let dateObj = new Date();
    //     let resultItem : LotteryFFCResult = {
    //         minuteDefine : `${dateObj.getHours()}:${dateObj.getMinutes()}`,
    //         zodiac : this.ChineseZodiacArray[resultIndex]
    //     };
    //     this.historyResultArray.push( resultItem );
    //     // TODO 分分彩 开奖 发送开奖实践
    //     // this.mGameLayer.FFCPrize( this.ChineseZodiacArray[resultIndex] );
    //
    //     //注册下一次的开奖回调
    //     this.mGameLayer.scheduleOnce(()=>{
    //         this.openPrize();
    //     },this.lotterySeconds);
    // }

    /**
     * 开始
     */
    start(){
        // let currSeconds = new Date().getSeconds();
        // this.mGameLayer.scheduleOnce(()=>{
        //     this.openPrize();
        // },60 - currSeconds );
    }

    /**
     * 开奖
     */
    openPrize(){
        if  ( this.historyResultArray.length == 20 ) {
            this.historyResultArray.pop();
        }
        let lotterySpecialSwitch : boolean = false;
        let betLotteryStr = this.currBetLotteryNumber.join("");
        let openPrizeResult = ``;
        let effectParams : { key : number,value : number }[] = [];

        if ( this.mGameLayer.gameManager.getCurrentDay() == 2 &&
            ( betLotteryStr == "1112" || betLotteryStr == "8888" ) ) {
            //如果是第三天，特殊情况的话
            if( betLotteryStr == "1112" ){
                openPrizeResult += `恭喜！您昨日购买的彩票中将了,奖金为128`;
                effectParams.push({ key:EventParamsTypeConstant.MONEY,value:128});
            }else{
                let randomNum = Math.floor( Math.random() * 10000 );
                if ( randomNum <= 10 ) {
                    openPrizeResult += `恭喜！您昨日购买的彩票中将了,奖金为10000`;
                    effectParams.push({ key:EventParamsTypeConstant.MONEY,value:10000});
                }else{
                    openPrizeResult += `恭喜！您昨日购买的彩票中将了,奖金为888`;
                    effectParams.push({ key:EventParamsTypeConstant.MONEY,value:888});
                }
            }
            lotterySpecialSwitch = true;
        }else{
            //普通开奖
            let resultIndex = Math.floor( Math.random() * LotteryFFCManager.MAX_LOTTERY_VALUE ) ;
            let dateObj = new Date();
            let resultItem : LotteryFFCResult = {
                minuteDefine : `${dateObj.getHours()}:${dateObj.getMinutes()}`,
                lotteryNum : resultIndex
            };
            this.historyResultArray.push( resultItem );
            // 开奖 发送开奖实践
            // this.mGameLayer.FFCPrize( this.ChineseZodiacArray[resultIndex] );
            let prizeNum : number =  Math.floor( Math.random() * 1000 );
            let prizeMoney : number = 0;//奖金金额
            let prizeStr : string = "";//
            if ( prizeNum < 2 ){
                //特等奖
                prizeMoney = 10000;
                prizeStr = "特等奖";
            }else if ( prizeNum < 5 ) {
                //一等奖
                prizeMoney = 1000;
                prizeStr = "一等奖";
            }else if ( prizeNum < 20 ){
                //二等奖
                prizeMoney = 200
                prizeStr = "二等奖";
            }else if ( prizeNum < 100 ){
                //三等奖
                prizeMoney = 88;
                prizeStr = "三等奖";
            }
            if ( prizeMoney > 0 ){
                //中奖
                openPrizeResult += `恭喜！您昨日购买的彩票中了${prizeStr},奖金为${prizeMoney}`
                effectParams.push({ key:EventParamsTypeConstant.MONEY,value:prizeMoney});
            }else{
                //未中奖
                openPrizeResult += `很遗憾你昨日彩票未中奖,谢谢惠顾`
            }
        }
        this.mGameLayer.addEvent( 24 , openPrizeResult , effectParams , lotterySpecialSwitch );
        //注册下一次的开奖回调
        // this.mGameLayer.scheduleOnce(()=>{
        //     this.openPrize();
        // },this.lotterySeconds);
    }

    /**
     * 下注一个
     * @param lotteryNum 号码
     */
    betOne( lotteryNum : number[] ){
        this.currBetLotteryNumber = this.currBetLotteryNumber.concat( lotteryNum );
        this.openPrize();
    }

    reset(){
       this.currBetLotteryNumber = [];
    }



}
